// styles
import styled from 'styled-components';

export const StyledDateLabel = styled.label`
    color: #005ba8;
    cursor: pointer;
    height: 17px;
`;
